import { startStimulusApp } from '@symfony/stimulus-bridge';
import { registerVueControllerComponents } from '@symfony/ux-vue';

// TODO: orderReturn.js koennte ebenfalls auf initVueApp() umgestellt werden,
// VoucherOrder haette dann einen eigenen voucherOrder.js-Entry statt js/orderReturn zu leihen.
// Verhaltensgleich, aber ausserhalb des Checkout-Scopes zurueckgestellt.
export function initVueApp() {
    const app = startStimulusApp(require.context(
        '@symfony/stimulus-bridge/lazy-controller-loader!../../vue/views', true, /\.(j|t)sx?$/
    ));
    registerVueControllerComponents(require.context('../../vue/views', true, /\.vue$/, 'lazy'));
    return app;
}
